import {KMDCFSIntro} from "./KMDCFSIntro";
import {KennethMustDie} from "../../KennethMustDie";
import {KMDGameMode} from "../../server/KMDGameMode";
import {gsap} from "gsap";
import {KMD_SYMBOL_ANIMATIONS, SPECIAL_SYMBOL_NAMES} from "../../server/IKMDData";
import {KMDSound} from "../../sound/KMDSound";

export class KMDSFSIntro extends KMDCFSIntro {

    private readonly _featureExplainXH: PIXI.spine.Spine;
    private readonly _featureExplainXHLock: PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "KMDSFSIntro";

        const xH: PIXI.spine.Spine = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset(SPECIAL_SYMBOL_NAMES.XH)),
            lock: PIXI.spine.Spine = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("locks"));

        xH.position.set(((2 * KennethMustDie.SYMBOL_WIDTH) + KennethMustDie.SYMBOL_WIDTH / 2), (KennethMustDie.SYMBOL_HEIGHT) + KennethMustDie.MAIN_REELS_TOP);
        lock.position = xH.position;

        xH.state.setAnimation(0, KMD_SYMBOL_ANIMATIONS.NORMAL, false);
        KennethMustDie.createTimelineForAnimation(lock, 0, "locked_150_start", false).totalProgress(1);

        xH.visible = lock.visible = false;
        this.addChild(xH, lock);

        this._featureExplainXH = xH;
        this._featureExplainXHLock = lock;
    }

    protected getFeatureExplainTl(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this._featureExplainXH.alpha = this._featureExplainXHLock.alpha = 1;
            this._featureExplainXH.visible = this._featureExplainXHLock.visible = true;
        });
        tl.add(super.getFeatureExplainTl());

        return tl;
    }

    protected getAssetName(): string {
        return ("sfsIntro");
    }

    protected playIntroSound(): void {
        KennethMustDie.soundPlayer.playSound(KMDSound.SFS_INTRO_IMPACT);

        KennethMustDie.soundPlayer.switchMusic("sfsIntro");
    }

    protected playBtnSound(): void {
        KennethMustDie.soundPlayer.playSound(KMDSound.BTN_START_SFS);
    }

    protected checkForUpgrade(): boolean {
        return (KennethMustDie.model.gameData.mode === KMDGameMode.FREESPIN || KennethMustDie.model.gameData.mode === KMDGameMode.FREESPIN_AVALANCHE) ||
            (KennethMustDie.model.gameData.mode === KMDGameMode.FREESPIN_COOL || KennethMustDie.model.gameData.mode === KMDGameMode.FREESPIN_COOL_AVALANCHE);
    }

    protected getOutroNameForUpgrade(): string {
        return "cool_outro";
    }

    protected getPreTransition(): void {
    }

    protected getTransition(): gsap.core.Timeline {
        return gsap.timeline();
    }

    protected getExtraFS(): number {
        return (KennethMustDie.model.gameData.mode.indexOf("FREESPIN_COOL") > -1 ? 1 : 2);
    }

    protected hideXHExplainFeature(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to([this._featureExplainXH, this._featureExplainXHLock], {
            duration: 0.2,
            alpha: 0
        }, "<");

        tl.add(() => {
            this._featureExplainXH.visible = this._featureExplainXHLock.visible = false;
        });

        return tl;
    }
}